import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { RegionService } from '../proxy/planning/controllers/region.service';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { VendorService } from '@controlling/proxy/controlling/controllers/vendor.service';
import { PropertyService } from '@planning/proxy/planning/controllers/property.service';
import { StorageLocationService } from '@controlling/proxy/controlling/controllers/storage-location.service';
import { ZoneService } from '../proxy/planning/controllers/zone.service';
import { PersonService } from '@general/proxy/general/controllers/person.service';

FieldBuilder.setNamespace('Planning');

export const DEPOSIT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Deposit.Name')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Deposit.Code')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('managerId', 'Entity.Deposit.Manager', PersonService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .display('fantasyName')
    .keyField('id')
    .build(),
  FieldBuilder
    .checkbox('isSapGenericDeposit', 'Entity.Deposit.IsSapGenericDeposit')
    .build(),
  FieldBuilder
    .text('address', 'Entity.Deposit.Address')
    .maxLength(70)
    .build(),
  FieldBuilder
    .text('psigCode', 'Entity.Deposit.PsigCode')
    .maxLength(12)
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.Deposit.IsActive')
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .displayFromNested('property.name')
    .sortBy('property.name')
    .build(),
  FieldBuilder
    .text('batchPrefix', 'Entity.Deposit.BatchPrefix')
    .maxLength(10)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('storageLocationId', 'Entity.StorageLocation', StorageLocationService)
    .displayFromNested('storageLocation.name')
    .sortBy('storageLocation.name')
    .build(),
  FieldBuilder
    .text('trackingNumber', 'Entity.Deposit.TrackingNumber')
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .checkbox('isThirdParty', 'Entity.Deposit.IsThirdParty')
    .build(),
];

export const DEPOSIT_CONFIG = {
  entityName: 'Deposit',
  localizationKey: 'Planning::Entity.Deposit',
  permission: 'PlanningLocation.Deposits',
  fields: DEPOSIT_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
